import React, { useEffect, useState, useCallback, useRef } from "react";
import { Modal, Form, Input, Select, Checkbox, Space, Radio, Spin, AutoComplete } from "antd";
import { Wrapper } from "../style";
import { MakeApiCall } from "../../../../apis";

const { Option } = Select;

// Common country codes — code only, no flags
const COUNTRY_CODES = [
    { code: '+1',   country: 'US/CA' },
    { code: '+7',   country: 'Russia' },
    { code: '+20',  country: 'Egypt' },
    { code: '+27',  country: 'South Africa' },
    { code: '+30',  country: 'Greece' },
    { code: '+31',  country: 'Netherlands' },
    { code: '+32',  country: 'Belgium' },
    { code: '+33',  country: 'France' },
    { code: '+34',  country: 'Spain' },
    { code: '+36',  country: 'Hungary' },
    { code: '+39',  country: 'Italy' },
    { code: '+40',  country: 'Romania' },
    { code: '+41',  country: 'Switzerland' },
    { code: '+43',  country: 'Austria' },
    { code: '+44',  country: 'UK' },
    { code: '+45',  country: 'Denmark' },
    { code: '+46',  country: 'Sweden' },
    { code: '+47',  country: 'Norway' },
    { code: '+48',  country: 'Poland' },
    { code: '+49',  country: 'Germany' },
    { code: '+51',  country: 'Peru' },
    { code: '+52',  country: 'Mexico' },
    { code: '+54',  country: 'Argentina' },
    { code: '+55',  country: 'Brazil' },
    { code: '+56',  country: 'Chile' },
    { code: '+57',  country: 'Colombia' },
    { code: '+60',  country: 'Malaysia' },
    { code: '+61',  country: 'Australia' },
    { code: '+62',  country: 'Indonesia' },
    { code: '+63',  country: 'Philippines' },
    { code: '+64',  country: 'New Zealand' },
    { code: '+65',  country: 'Singapore' },
    { code: '+66',  country: 'Thailand' },
    { code: '+81',  country: 'Japan' },
    { code: '+82',  country: 'South Korea' },
    { code: '+84',  country: 'Vietnam' },
    { code: '+86',  country: 'China' },
    { code: '+90',  country: 'Turkey' },
    { code: '+91',  country: 'India' },
    { code: '+92',  country: 'Pakistan' },
    { code: '+93',  country: 'Afghanistan' },
    { code: '+94',  country: 'Sri Lanka' },
    { code: '+95',  country: 'Myanmar' },
    { code: '+98',  country: 'Iran' },
    { code: '+212', country: 'Morocco' },
    { code: '+213', country: 'Algeria' },
    { code: '+216', country: 'Tunisia' },
    { code: '+218', country: 'Libya' },
    { code: '+220', country: 'Gambia' },
    { code: '+234', country: 'Nigeria' },
    { code: '+254', country: 'Kenya' },
    { code: '+255', country: 'Tanzania' },
    { code: '+256', country: 'Uganda' },
    { code: '+260', country: 'Zambia' },
    { code: '+263', country: 'Zimbabwe' },
    { code: '+351', country: 'Portugal' },
    { code: '+352', country: 'Luxembourg' },
    { code: '+353', country: 'Ireland' },
    { code: '+358', country: 'Finland' },
    { code: '+380', country: 'Ukraine' },
    { code: '+381', country: 'Serbia' },
    { code: '+385', country: 'Croatia' },
    { code: '+386', country: 'Slovenia' },
    { code: '+420', country: 'Czech Republic' },
    { code: '+421', country: 'Slovakia' },
    { code: '+880', country: 'Bangladesh' },
    { code: '+966', country: 'Saudi Arabia' },
    { code: '+971', country: 'UAE' },
    { code: '+972', country: 'Israel' },
    { code: '+973', country: 'Bahrain' },
    { code: '+974', country: 'Qatar' },
    { code: '+975', country: 'Bhutan' },
    { code: '+977', country: 'Nepal' },
    { code: '+994', country: 'Azerbaijan' },
    { code: '+998', country: 'Uzbekistan' },
];

function AddNewAlerts({
                          isModalVisible,
                          handleCancel,
                          handleSubmit,
                          editing,
                          userData,
                          asinList,
                          alertCategories,
                          alertDataMap,
                          fetchProductList,
                          isSearching,
                          hasMore,
                          page,
                          searchText
                      }) {

    const [form] = Form.useForm();
    const receiveOnWatch = Form.useWatch('receive_on', form);
    const [alertTypes, setAlertTypes] = useState({});
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedAlertType, setSelectedAlertType] = useState(null);
    const [alertLogicType, setAlertLogicType] = useState(null);
    const [localSelectedAsins, setLocalSelectedAsins] = useState([]);
    const [whatsappCountryCode, setWhatsappCountryCode] = useState('+91');

    // --- Contact suggestions state ---
    const [allEmailSuggestions, setAllEmailSuggestions] = useState([]);   // full list from API
    const [allMobileSuggestions, setAllMobileSuggestions] = useState([]); // full list from API
    const [emailOptions, setEmailOptions] = useState([]);                  // filtered for dropdown
    const [mobileOptions, setMobileOptions] = useState([]);                // filtered for dropdown
    const [suggestionsLoading, setSuggestionsLoading] = useState(false);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => { isMounted.current = false; };
    }, []);

    // Fetch once when modal opens
    useEffect(() => {
        if (!isModalVisible) return;

        const fetchSuggestions = async () => {
            setSuggestionsLoading(true);
            try {
                const response = await MakeApiCall(
                    'get-contact-details-suggestions',
                    'get',
                    null,
                    true,
                    {},
                    userData?.token
                );
                if (!isMounted.current) return;
                if (response?.status) {
                    const emails = (response.data?.emails || []).map(e => ({ value: e, label: e }));
                    const mobiles = (response.data?.mobile_numbers || []).map(n => ({ value: n, label: n }));
                    setAllEmailSuggestions(emails);
                    setAllMobileSuggestions(mobiles);
                    // Show all by default when field is empty
                    setEmailOptions(emails);
                    setMobileOptions(mobiles);
                }
            } catch (e) {
                console.error('Failed to fetch contact suggestions:', e);
            } finally {
                if (isMounted.current) setSuggestionsLoading(false);
            }
        };

        fetchSuggestions();
    }, [isModalVisible, userData?.token]);

    // Filter email options as the user types
    const handleEmailSearch = (searchVal) => {
        if (!searchVal) {
            setEmailOptions(allEmailSuggestions);
        } else {
            setEmailOptions(
                allEmailSuggestions.filter(s =>
                    s.value.toLowerCase().includes(searchVal.toLowerCase())
                )
            );
        }
    };

    // Filter mobile options as the user types
    const handleMobileSearch = (searchVal) => {
        if (!searchVal) {
            setMobileOptions(allMobileSuggestions);
        } else {
            setMobileOptions(
                allMobileSuggestions.filter(s => s.value.includes(searchVal))
            );
        }
    };

    // When a suggestion is selected, try to split country code from the number
    // API stores numbers like "917838406232" or "+91-7838406232"
    const handleMobileSelect = (selectedVal) => {
        // Format 1: already split e.g. "+91-7838406232"
        if (selectedVal.includes('-')) {
            const parts = selectedVal.split('-');
            if (parts.length === 2) {
                const matchedCode = COUNTRY_CODES.find(c => c.code === parts[0]);
                if (matchedCode) {
                    setWhatsappCountryCode(parts[0]);
                    form.setFieldsValue({ whatsapp_number: parts[1] });
                    return;
                }
            }
        }

        // Format 2: raw digits, try to match known country code prefix
        // Sort codes longest-first so +971 matches before +97
        const sortedCodes = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);
        const digitsOnly = selectedVal.replace(/^\+/, ''); // strip leading + if any

        for (const { code } of sortedCodes) {
            const codeDigits = code.replace('+', '');
            if (digitsOnly.startsWith(codeDigits)) {
                setWhatsappCountryCode(code);
                form.setFieldsValue({ whatsapp_number: digitsOnly.slice(codeDigits.length) });
                return;
            }
        }

        // Fallback: put as-is into number field, keep existing country code
        form.setFieldsValue({ whatsapp_number: selectedVal });
    };

    const handlePopupScroll = useCallback((e) => {
        const { target } = e;
        if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
            if (!isSearching && hasMore) {
                fetchProductList(searchText, page + 1, true);
            }
        }
    }, [isSearching, hasMore, page, searchText, fetchProductList]);

    useEffect(() => {
        const types = {};
        Object.entries(alertDataMap.types).forEach(([category, typeMap]) => {
            types[category] = Object.entries(typeMap).map(([key, label]) => ({
                label,
                value: key
            }));
        });
        setAlertTypes(types);

        if (editing) {
            let asinArray = [];
            try {
                asinArray = typeof editing.asin_list === "string" ? JSON.parse(editing.asin_list) : editing.asin_list;
            } catch (err) {
                console.error("Failed to parse asin_list:", err);
            }
            setLocalSelectedAsins(Array.isArray(asinArray) ? asinArray : []);
            const logic = alertDataMap.logicTypeMap?.[editing.type]?.type || "Default";
            setAlertLogicType(logic);
        } else {
            setLocalSelectedAsins([]);
            setAlertLogicType(null);
        }
    }, [alertDataMap.types, alertDataMap.logicTypeMap, editing]);

    useEffect(() => {
        if (editing) {
            let frequencyValue = 2;
            let daysValue = null;

            if (editing.frequency !== "Everytime") {
                frequencyValue = 1;
                daysValue = parseInt(editing.frequency, 10);
            }

            // Parse existing send_on_mobile_number e.g. "+91-7838406232"
            let parsedCode = '+91';
            let parsedNumber = '';
            if (editing?.send_on_mobile_number) {
                const parts = editing.send_on_mobile_number.split('-');
                if (parts.length === 2) {
                    parsedCode = parts[0];
                    parsedNumber = parts[1];
                } else {
                    parsedNumber = editing.send_on_mobile_number;
                }
            }
            setWhatsappCountryCode(parsedCode);

            form.setFieldsValue({
                ...editing,
                alertType: editing.type,
                frequency: frequencyValue,
                days: daysValue,
                receive_on: editing.receive_on || [],
                severity: editing.severity || "Medium",
                email: editing?.send_on_emails,
                whatsapp_number: parsedNumber,
            });

            setSelectedCategory(editing.category);
            setSelectedAlertType(editing.type);
        } else {
            form.resetFields();
            setSelectedCategory(null);
            setSelectedAlertType(null);
            setAlertLogicType(null);
            setWhatsappCountryCode('+91');
            form.setFieldsValue({
                frequency: 2,
                severity: "Medium",
            });
        }
    }, [editing, isModalVisible]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();

            const payload = {
                name: values.name,
                category: values.category,
                type: values.alertType,
                frequency: values.frequency === 1 ? `${values.days}` : "Everytime",
                receive_on: values.receive_on || [],
                asin_list: localSelectedAsins || [],
                severity: values.severity,
                send_on_emails: values?.email,
            };

            // Combine country code + number: e.g. "+91-7838406232"
            if (values.receive_on?.includes('Whatsapp')) {
                payload.send_on_mobile_number = `${whatsappCountryCode}-${values.whatsapp_number}`;
            }

            if (alertDataMap.logicTypeMap?.[values.alertType]?.type === "Custom") {
                payload.user_input = values.user_input;
            }

            handleSubmit(payload);
        } catch (errorInfo) {
            console.log("Validation Failed:", errorInfo);
        }
    };

    return (
        <>
            <Modal
                visible={isModalVisible}
                title={editing ? "Edit Alerts" : "Add New Alerts"}
                onCancel={handleCancel}
                width={600}
                destroyOnClose
                footer={[
                    <React.Fragment key="footer-btns">
                        <button type="button" className="btn btn-light me-3" onClick={handleCancel}>Close</button>
                        <button type="button" className="btn btn-danger" onClick={handleOk}>{editing ? "Update" : "Save"}</button>
                    </React.Fragment>
                ]}
            >
                <Wrapper>
                    <div className="modal_custom add-alert">
                        <Form form={form} layout="vertical" name="expenseForm" initialValues={{ frequency: 2, severity: "Medium" }}>

                            <div className="row g-5 mb-0 align-items-center">
                                <div className="col-md-12">
                                    <Form.Item label="" name="name" className="mb-0 fw-bold"
                                               rules={[{required: true, message: "Please enter alert name"}]}>
                                        <Input className="form-control form-control-solid fs-7"
                                               placeholder="Enter Alert Name"/>
                                    </Form.Item>
                                </div>

                                <div className="col-md-6">
                                    <Form.Item shouldUpdate={() => true} noStyle>
                                        {({ getFieldError }) => {
                                            const errors = getFieldError('category');
                                            return (
                                                <Form.Item
                                                    label=""
                                                    required
                                                    className="mb-4 fw-bold"
                                                    validateStatus={errors.length ? "error" : ""}
                                                    help={errors.length > 0 && (
                                                        <div style={{ marginTop: '10px', color: '#ff4d4f' }}>
                                                            {errors[0]}
                                                        </div>
                                                    )}
                                                >
                                                    <Form.Item name="category" noStyle rules={[{ required: true, message: "Please select a category" }]}>
                                                        <Select
                                                            placeholder="Select Category"
                                                            onChange={(value) => {
                                                                setSelectedCategory(value);
                                                                form.setFieldsValue({alertType: undefined});
                                                            }}
                                                        >
                                                            {alertCategories.map(option => (
                                                                <Option key={option.value} value={option.value}>{option.label}</Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Form.Item>
                                            );
                                        }}
                                    </Form.Item>
                                </div>

                                <div className="col-md-6">
                                    <Form.Item shouldUpdate={() => true} noStyle>
                                        {({ getFieldError }) => {
                                            const errors = getFieldError('alertType');
                                            return (
                                                <Form.Item
                                                    label=""
                                                    required
                                                    className="mb-4"
                                                    validateStatus={errors.length ? "error" : ""}
                                                    help={errors.length > 0 && (
                                                        <div style={{ marginTop: '10px', color: '#ff4d4f' }}>
                                                            {errors[0]}
                                                        </div>
                                                    )}
                                                >
                                                    <Form.Item name="alertType" noStyle rules={[{ required: true, message: "Please select an alert type" }]}>
                                                        <Select
                                                            placeholder="Select Alert Type"
                                                            disabled={!selectedCategory}
                                                            onChange={(value) => {
                                                                setSelectedAlertType(value);
                                                                const logic = alertDataMap.logicTypeMap?.[value]?.type || "Default";
                                                                setAlertLogicType(logic);
                                                                form.setFieldsValue({user_input: null});
                                                            }}
                                                        >
                                                            {alertTypes[selectedCategory]?.map((option) => (
                                                                <Option key={option.value} value={option.value}>
                                                                    {option.label}
                                                                </Option>
                                                            )) || null}
                                                        </Select>
                                                    </Form.Item>
                                                </Form.Item>
                                            );
                                        }}
                                    </Form.Item>
                                </div>

                                <div className="col-md-12">
                                    <Form.Item className="fw-bold mb-4" label="">
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            placeholder="Search SKU, Title or ASIN"
                                            className="w-100"
                                            size="large"
                                            value={localSelectedAsins}
                                            onChange={setLocalSelectedAsins}
                                            onSearch={(val) => fetchProductList(val, 1, false)}
                                            onPopupScroll={handlePopupScroll}
                                            filterOption={false}
                                            loading={isSearching}
                                            optionLabelProp="value"
                                            maxTagCount={"responsive"}
                                            notFoundContent={isSearching ? <div className="text-center p-2"><Spin size="small"/></div> : null}
                                        >
                                            {asinList.map((item) => (
                                                <Option key={item.asin} value={item.asin}>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <img
                                                            src={item.image || "https://app.sellerview.ai/sellerview_api/images/no-product-image.png"}
                                                            alt=""
                                                            className="w-40px h-40px rounded border object-fit-contain"
                                                        />
                                                        <div className="flex-grow-1" style={{minWidth: 0}}>
                                                            <div className="fw-bolder text-dark text-truncate" style={{fontSize: '12px'}}>
                                                                {item.name}
                                                            </div>
                                                            <div className="fs-12 text-muted d-flex align-items-center" style={{gap: '8px'}}>
                                                                <span className="badge badge-light-danger fw-bold">{item.asin}</span>
                                                                {item.sku && (
                                                                    <span className="text-truncate" style={{maxWidth: '160px'}}>
                                                                        <small>SKU: <span className="fw-bold text-dark">{item.sku}</span></small>
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Option>
                                            ))}
                                            {isSearching && hasMore && (
                                                <Option disabled key="loading-more" className="text-center bg-light">
                                                    <Spin size="small" /> <small className="ms-2">Loading more...</small>
                                                </Option>
                                            )}
                                        </Select>
                                    </Form.Item>
                                </div>

                                <div className="col-md-12">
                                    {alertLogicType === "Custom" && (
                                        <div className="col-md-12">
                                            <Form.Item
                                                label=""
                                                name="user_input"
                                                className="mb-4"
                                                rules={[{required: true, message: "Please enter a threshold value"}]}
                                            >
                                                <Space>
                                                    <div className="fw-bold fs-7">
                                                        {alertDataMap.logicTypeMap?.[selectedAlertType]?.description || "Enter threshold percentage"}
                                                    </div>
                                                    <Input
                                                        type="number"
                                                        className="w-125px fs-7"
                                                        placeholder="Percentage"
                                                        suffix="%"
                                                        variant="filled"
                                                        size="large"
                                                    />
                                                </Space>
                                            </Form.Item>
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-12">
                                    <Form.Item name="frequency" className="d-flex align-items-center fw-bold">
                                        <Radio.Group name="notificationFrequency">
                                            <Space direction="vertical">
                                                <Radio value={1}>
                                                    Send me a notification every
                                                    <Form.Item noStyle shouldUpdate={(p, c) => p.frequency !== c.frequency}>
                                                        {({getFieldValue}) => (
                                                            <Form.Item
                                                                name="days"
                                                                noStyle
                                                                rules={[{ required: getFieldValue('frequency') === 1, message: "Required" }]}
                                                            >
                                                                <Input
                                                                    type="number"
                                                                    min={1}
                                                                    className="w-125px mx-3 fs-7"
                                                                    variant="filled"
                                                                    disabled={getFieldValue('frequency') !== 1}
                                                                />
                                                            </Form.Item>
                                                        )}
                                                    </Form.Item>
                                                    day(s)
                                                </Radio>
                                                <Radio className="mt-3" value={2}>
                                                    Send me a notification every time the change happens.
                                                </Radio>
                                            </Space>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>

                                <div className="col-md-12">
                                    <Form.Item
                                        name="severity"
                                        label="Severity"
                                        className="fw-bold"
                                        rules={[{required: true, message: "Please select a severity level"}]}
                                    >
                                        <Radio.Group>
                                            <Radio value="Minor">Minor</Radio>
                                            <Radio value="Major">Major</Radio>
                                            <Radio value="Critical">Critical</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>

                                <div className="col-md-12">
                                    <Form.Item name="receive_on" className="fw-bold" label="Receive Alert On">
                                        <Checkbox.Group>
                                            {alertDataMap.receive_on.map((option) => (
                                                <Checkbox key={option} value={option}>{option}</Checkbox>
                                            ))}
                                        </Checkbox.Group>
                                    </Form.Item>
                                </div>

                                {/* ── Email field with suggestions ── */}
                                {receiveOnWatch?.includes('Email') && (
                                    <div className="col-md-12">
                                        <Form.Item shouldUpdate={() => true} noStyle>
                                            {({ getFieldError }) => {
                                                const errors = getFieldError('email');
                                                return (
                                                    <Form.Item
                                                        label="Email"
                                                        required
                                                        className="fw-bold mb-4"
                                                        validateStatus={errors.length ? "error" : ""}
                                                        help={errors.length > 0 && (
                                                            <div style={{ marginTop: '10px', color: '#ff4d4f' }}>
                                                                {errors[0]}
                                                            </div>
                                                        )}
                                                    >
                                                        <Form.Item name="email" noStyle rules={[
                                                            { required: true, message: "Please enter an email address" },
                                                            { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "Please enter a valid email" }
                                                        ]}>
                                                            <AutoComplete
                                                                options={emailOptions}
                                                                onSearch={handleEmailSearch}
                                                                onFocus={() => setEmailOptions(allEmailSuggestions)}
                                                                placeholder="Enter or select Email Address"
                                                                notFoundContent={
                                                                    suggestionsLoading
                                                                        ? <div className="text-center p-2"><Spin size="small" /></div>
                                                                        : null
                                                                }
                                                            />
                                                        </Form.Item>
                                                    </Form.Item>
                                                );
                                            }}
                                        </Form.Item>
                                    </div>
                                )}

                                {/* ── WhatsApp: country code Select + number AutoComplete side by side ── */}
                                {receiveOnWatch?.includes('Whatsapp') && (
                                    <div className="col-md-12">
                                        <Form.Item shouldUpdate={() => true} noStyle>
                                            {({ getFieldError }) => {
                                                const errors = getFieldError('whatsapp_number');
                                                return (
                                                    <Form.Item
                                                        label="WhatsApp Number"
                                                        required
                                                        className="fw-bold mb-4"
                                                        validateStatus={errors.length ? "error" : ""}
                                                        help={errors.length > 0 && (
                                                            <div style={{ marginTop: '10px', color: '#ff4d4f' }}>
                                                                {errors[0]}
                                                            </div>
                                                        )}
                                                    >
                                                        <div style={{ display: 'flex', gap: 8 }}>
                                                            <Select
                                                                value={whatsappCountryCode}
                                                                onChange={setWhatsappCountryCode}
                                                                showSearch
                                                                filterOption={(input, option) =>
                                                                    option?.value?.includes(input)
                                                                }
                                                                style={{ width: 100 }}
                                                                dropdownStyle={{ minWidth: 110 }}
                                                                popupMatchSelectWidth={false}
                                                            >
                                                                {COUNTRY_CODES.map(({ code }) => (
                                                                    <Option key={code} value={code}>{code}</Option>
                                                                ))}
                                                            </Select>

                                                            <Form.Item name="whatsapp_number" noStyle rules={[
                                                                { required: true, message: "Please enter a WhatsApp number" },
                                                                { pattern: /^[0-9]{6,14}$/, message: "Please enter a valid number (digits only)" }
                                                            ]}>
                                                                <AutoComplete
                                                                    style={{ flex: 1 }}
                                                                    options={mobileOptions}
                                                                    onSearch={handleMobileSearch}
                                                                    onSelect={handleMobileSelect}
                                                                    onFocus={() => setMobileOptions(allMobileSuggestions)}
                                                                    placeholder="Enter or select number"
                                                                    notFoundContent={
                                                                        suggestionsLoading
                                                                            ? <div className="text-center p-2"><Spin size="small" /></div>
                                                                            : null
                                                                    }
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    </Form.Item>
                                                );
                                            }}
                                        </Form.Item>
                                    </div>
                                )}

                            </div>
                        </Form>
                    </div>
                </Wrapper>
            </Modal>
        </>
    );
}

export default AddNewAlerts;